import apiService from '../utils/apiInterceptor';

const stripeSettingsService = {
  getAll: () => apiService.get('/admin/stripe-settings'),
  updateAll: accounts => apiService.put('/admin/stripe-settings', { accounts }),
};

export default stripeSettingsService;
